import { get, post } from 'utils/network';
import { PaymentMethod, Token } from '../../models/payment.types';
import { ApiRoute } from '../../utils/config';

// fetch the braintree payment token needed for the Drop-in UI
export const fetchPaymentToken = async (): Promise<Token | undefined> => {
  const {
    ok,
    parsedBody,
  } = await get<Token>(ApiRoute.PAYMENT_TOKEN);

  if (!ok) {
    throw new Error('Network response was not ok');
  }

  return parsedBody;
};

export const savePaymentMethod = async (paymentMethod: PaymentMethod): Promise<void> => {
  const body = {
    user: {
      payment_method_attributes: {
        token: paymentMethod.nonce,
        cc_last_four: paymentMethod.details.lastFour,
        cc_brand: paymentMethod.details.cardType,
        cc_exp_month: paymentMethod.details.expirationMonth,
        cc_exp_year: paymentMethod.details.expirationYear,
        provider_name: paymentMethod.providerName,
      },
    },
  };

  const {
    ok,
    parsedBody,
  } = await post<{ details?: string }>(ApiRoute.PAYMENT_METHOD, body);

  if (!ok) {
    if (parsedBody?.details) {
      Rollbar.error(parsedBody?.details);
    }
    throw new Error(parsedBody?.details || 'There was a problem processing your credit card. Please update your information.');
  }
};
